export const comeGoNotificationAreas = Object.freeze({
  PICK_UP_ACTIVITY: 'PickupActivity',
  VACATION_REQUEST: 'VacationRegistrationRequest',
});
